module.exports = __webpack_public_path__ + "static/media/team 7 Sixes and Sevens.47420340.png";